import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MenuAdjustDrawer from '@/views/mallDecoration/components/menuAdjustDrawer.vue';
import CinemaAdjustRule from '@/views/goodsCenter/cinemaAdjustRule.vue';
import ZydSetDiscount from '@/views/goodsCenter/cakeComponents/zydSetDiscount.vue';
import TicketAdjustRule from '@/views/goodsCenter/ticketAdjustRuleList.vue';
import cakeHomeAdjustRuleList from '@/views/goodsCenter/cakeHomeAdjustRuleList.vue';
import cakeStoreAdjustRuleList from '@/views/goodsCenter/cakeStoreAdjustRuleList.vue';
import OnlineDiscount from '@/views/goodsCenter/onlineComponents/onlineDiscount.vue';
import flowerAdjustRuleList from '@/views/goodsCenter/flowerAdjustRuleList.vue';
import NewPerformAdjustRuleList from '@/views/goodsCenter/newPerformAdjustRuleList.vue';
export default {
  name: "customerPriceAdjustmentRulesList",
  components: {
    NewPerformAdjustRuleList: NewPerformAdjustRuleList,
    OnlineDiscount: OnlineDiscount,
    TicketAdjustRule: TicketAdjustRule,
    ZydSetDiscount: ZydSetDiscount,
    CinemaAdjustRule: CinemaAdjustRule,
    MenuAdjustDrawer: MenuAdjustDrawer,
    cakeHomeAdjustRuleList: cakeHomeAdjustRuleList,
    cakeStoreAdjustRuleList: cakeStoreAdjustRuleList,
    flowerAdjustRuleList: flowerAdjustRuleList
  },
  props: {
    goodsData: {
      type: Array,
      return: function _return() {
        return [];
      }
    },
    menuData: {
      type: Array,
      return: function _return() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      menuRule: false,
      drawerTitle: '',
      trendParams: {},
      drawerGood: false,
      drawerTitleGood: '',
      trendParamsGood: {},
      goodsType: ''
    };
  },
  methods: {
    // 菜单查看规则
    watchMenuRule: function watchMenuRule(row) {
      this.trendParams = {
        category_id: row.category_id,
        company_name: row.company_name
      };
      this.menuRule = true;
      this.drawerTitle = "<span style=\"color: #000\">\u5BA2\u6237\u89C4\u5219</span> <span style=\"color: red;margin-left: 20px\">\u83DC\u5355\uFF1A".concat(row.category_name, " (ID:").concat(row.category_id, ")</span>");
    },
    // 商品中心查看规则
    watchGoodsRule: function watchGoodsRule(row) {
      this.trendParamsGood = {
        rule_id: row.rule_id,
        company_name: row.company_name
      };
      this.goodsType = row.goods_type;
      this.drawerGood = true;
      this.drawerTitleGood = "<span style=\"color: #000\">".concat(row.type, "</span> <span style=\"color: red;margin-left: 10px\"> ").concat(row.rule_name, " (ID:").concat(row.rule_id, ")</span>");
    }
  }
};